// extracted by mini-css-extract-plugin
export default {"container":"container--zF23g","imageWrap":"imageWrap--zF23g","caption":"caption--zF23g"};